/**
 * Flatten search row / fullDeal for OrganizedTourObject (TourObject) props spread.
 * Matches legacy `<TourObject {...searchItem} />` contract.
 */
export function pickOrganizedTourDealSpread(deal) {
  if (!deal || typeof deal !== "object") return {};
  const full =
    deal.fullDeal && typeof deal.fullDeal === "object" ? deal.fullDeal : null;
  if (full) {
    return { ...full, ...deal, fullDeal: full, tour: deal.tour || full.tour };
  }
  return { ...deal };
}
